module.exports = __webpack_public_path__ + "static/media/Project2Diagram.540ad056.svg";